import * as ProgressPrimitive from '@radix-ui/react-progress';
import { VariantProps, cva } from 'class-variance-authority';
import * as React from 'react';

import { cn } from '../../utils';

const progressVariants = cva('h-full w-full flex-1 transition-all', {
  variants: {
    variant: {
      critical: 'bg-critical',
      default: 'bg-surface',
      weak: 'bg-weak',
    },
  },
  defaultVariants: {
    variant: 'default',
  },
});

const Progress = React.forwardRef<
  React.ElementRef<typeof ProgressPrimitive.Root>,
  React.ComponentPropsWithoutRef<typeof ProgressPrimitive.Root> &
    VariantProps<typeof progressVariants>
>(({ className, value, variant, ...props }, ref) => (
  <ProgressPrimitive.Root
    className={cn('relative h-1 w-full overflow-hidden rounded-full bg-surface-active', className)}
    ref={ref}
    {...props}
  >
    <ProgressPrimitive.Indicator
      style={{ transform: `translateX(-${100 - (value || 0)}%)` }}
      className={progressVariants({ variant })}
    />
  </ProgressPrimitive.Root>
));
Progress.displayName = ProgressPrimitive.Root.displayName;

export { Progress };
